import { createReducer } from '@mews/framework';
import { WEBSOCKET_SUBSCRIBED, WEBSOCKET_UNSUBSCRIBED } from './actionTypes';

const INITIAL_STATE = { subscriptions: {} };
const increaseSubscriptionCount = (subscriptions: $TSFixMe, subscriptionType: $TSFixMe) => {
    const currentCount: number = subscriptions[subscriptionType] ?? 0;
    return {
        ...subscriptions,
        [subscriptionType]: currentCount + 1,
    };
};
const decreaseSubscriptionCount = (subscriptions: $TSFixMe, subscriptionType: $TSFixMe) => {
    const { [subscriptionType]: currentCount, ...otherSubscriptions } = subscriptions;
    return currentCount > 1
        ? {
              ...otherSubscriptions,
              [subscriptionType]: currentCount - 1,
          }
        : otherSubscriptions;
};

export default createReducer(INITIAL_STATE, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [WEBSOCKET_SUBSCRIBED]: (state, payload) => ({
        ...state,
        subscriptions: increaseSubscriptionCount(state.subscriptions, payload),
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [WEBSOCKET_UNSUBSCRIBED]: (state, payload) => ({
        ...state,
        subscriptions: decreaseSubscriptionCount(state.subscriptions, payload),
    }),
});
